import { motion, useReducedMotion } from "motion/react";
import { Phone } from "lucide-react";
import { images, resort } from "@/data/resort";
import { ResortLink } from "../resort-button";
import { Eyebrow, MaskReveal, Reveal } from "../reveal";

export function AccommodationsCTA() {
  const reduced = useReducedMotion();

  return (
    <section
      aria-labelledby="acc-final-cta-heading"
      className="relative isolate overflow-hidden bg-primary text-primary-foreground"
    >
      <div className="overlay-forest absolute inset-0 -z-10" />

      <div className="shell py-20 md:py-28">
        <Reveal>
          <Eyebrow tone="light">Find Your Site</Eyebrow>
        </Reveal>
        <h2 id="acc-final-cta-heading" className="display-xl mt-6 max-w-[16ch]">
          <MaskReveal>Ready to Make Auburn</MaskReveal>
          <MaskReveal delay={0.08}>Your Base Camp?</MaskReveal>
        </h2>
        <Reveal delay={0.12}>
          <p className="mt-8 max-w-2xl text-base leading-relaxed text-primary-foreground/80 md:text-lg">
            Tell us when you&apos;re arriving and what you&apos;re traveling in, and we&apos;ll help
            you find the right available site.
          </p>
        </Reveal>
        <Reveal delay={0.18}>
          <div className="mt-10 flex w-full flex-col gap-3 sm:flex-row sm:flex-wrap">
            <ResortLink variant="gold" href="/reservations/" className="w-full sm:w-auto">
              Check Availability
            </ResortLink>
            <ResortLink variant="onDark" href={resort.phoneHref} className="w-full sm:w-auto">
              <Phone className="size-4" strokeWidth={1.6} /> Call the Resort
            </ResortLink>
          </div>
          <p className="eyebrow mt-8 text-primary-foreground/60">
            Pull-Through · Back-In · Accessible · Full Hookups · Daily · Weekly · Monthly
          </p>
        </Reveal>
      </div>
    </section>
  );
}
